<script lang="ts" module>
  import type { FooterLinkColumnStoryblok } from '~/component-types-sb';

  export interface FooterLinkColumnProps {
    blok: FooterLinkColumnStoryblok;
  }
</script>

<script lang="ts">
  import { FooterGroup } from "@agapi/ui/footer";
  import { storyblokEditable, StoryblokComponent } from "@storyblok/svelte";
  import { css } from '@agapi/ui/panda/css';

  const { blok }: FooterLinkColumnProps = $props();
</script>

<FooterGroup use={[[storyblokEditable, blok]]}>
  {#if blok.heading}
    <h2 class={css({textStyle: 'h5', pb: '2'})}>{blok.heading}</h2>
  {/if}
  {#each blok.links || [] as link}
    <StoryblokComponent blok={link} />
  {/each}
</FooterGroup>
